import { puzzlePlayPath } from '../puzzles/puzzleUrl';
import { buildReplayLocationState } from '../replay/replayLocationState';
import { replayGamePath } from '../replay/replayUrl';
import { REVIEW_CARD_PARAM } from '../review/reviewUrl';
import {
  ActivityInteraction,
  ActivityKind,
  ActivityPeriod,
} from './activityTypes';

export function activityDetailPath(
  kind: ActivityKind,
  period: ActivityPeriod | 'all' = 'all',
): string {
  return period === 'all'
    ? `/stats/${kind}`
    : `/stats/${kind}?period=${period}`;
}

export type ActivityInteractionTarget = {
  to: string;
  state?: unknown;
};

export function activityInteractionTarget(
  kind: ActivityKind,
  interaction: ActivityInteraction,
  period: ActivityPeriod | 'all' = 'all',
): ActivityInteractionTarget | null {
  const returnTo = activityDetailPath(kind, period);

  switch (kind) {
    case 'replay': {
      if (!interaction.gameId) {
        return null;
      }
      const vsMatch = interaction.label.match(/^(.+) vs (.+)$/);
      const meta = vsMatch
        ? { white: vsMatch[1], black: vsMatch[2] }
        : {};
      return {
        to: replayGamePath(interaction.gameId),
        state: buildReplayLocationState(meta, { returnTo }),
      };
    }
    case 'puzzles': {
      if (!interaction.puzzleId) {
        return null;
      }
      return {
        to: puzzlePlayPath(interaction.puzzleId),
      };
    }
    case 'srs': {
      if (interaction.lineId) {
        return {
          to: `/review/lines?line=${encodeURIComponent(interaction.lineId)}`,
        };
      }
      if (!interaction.cardId) {
        return null;
      }
      const reviewCategory = interaction.detail?.startsWith('puzzle review')
        ? 'puzzles'
        : interaction.detail?.toLowerCase().includes('course')
          ? 'courses'
          : 'games';
      return {
        to: `/review/${reviewCategory}?${REVIEW_CARD_PARAM}=${encodeURIComponent(interaction.cardId)}`,
      };
    }
  }
}
